module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAwUlEQVQoU32SAQ3CUAwFbw7AATjAAUjAAThgOJgDwAEWcIADcAASkEAuaZcOlv1k2db29V67NcAZ+PB/FsD+N9wAXVzmLLhGUY33uhS8gVWQNsC9iAaQSmgjo1DSJMGknZ3H7oonBRZuw/8s7s+xRWjJIe12Ai7AGkiraqTZ0NOZ8Bg4AMd4TjtpU7qL6QWK9G6BHbXju/QHsMy5kqDA5C6It9iUZOM2kTIg5IwW5dd3AVrxq/s3tJVQl2LX18iW5l/KHS29mbKo9wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Shape.png
// module id = sEV1
// module chunks = 2